import React, { useState, useEffect } from "react";
import Notification from "../../../Components/share/Notification/Notification";
import useFetch from "../../../Hooks/useFetch";

function Systemnotifications() {
    const [firstShow, setFirstShow] = useState(true);
    const [secondShow, setSecondShow] = useState(true);
    const [show, setShow] = useState(true);
    const [notifications, setNotifications] = useState();

    const getNotification = useFetch({
        method: "GET",
        url: `SystemAlarmingService`,
        noHeader: false,
        trigger: true,
        setter: setNotifications,
    });

    useEffect(() => {}, [notifications]);

    const closeFunction = (id) => {
        setNotifications({
            results: notifications.results.filter((i) => i.id !== id),
        });
        console.log(notifications.results);
    };

    return (
        <div>
            <h4 className="text-[2rem] text-black-prim font-bold mb-16">
                اعلانات سیستمی
            </h4>
            {notifications?.results.map((i) =>
                i.alarm_type === "1" ? (
                    <Notification
                        show={firstShow}
                        setShow={closeFunction}
                        kind="warning"
                        className="mb-[1.9rem]"
                        id={i.id}
                    >
                        {i.alarm_text}
                    </Notification>
                ) : i.alarm_type === "2" ? (
                    <Notification
                        show={secondShow}
                        setShow={closeFunction}
                        kind="negative"
                        className="mb-[1.9rem]"
                        id={i.id}
                    >
                        {i.alarm_text}
                    </Notification>
                ) : null
            )}
        </div>
    );
}

export default Systemnotifications;
